import cx from "clsx"
import { useRef } from "react"
import ReactQuill, { Quill } from "react-quill"
import "react-quill/dist/quill.snow.css"
import styles from "./richTextEditor.module.less"
const icons = Quill.import("ui/icons")

//make this prop based in future
icons["aiMagicClean"] = `<span style="display: inline-flex; align-items: center; gap: 4px;  background: #E6F5F9;
    border-radius: 38px;
    padding: 4px 8px; margin-top: -4px;">
  <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none">
    <foreignObject x="0" y="0" width="100%" height="100%">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style="
          background: linear-gradient(0deg, #6C54A3 0%, #00B1D2 100%);
          border-radius: 5rem;
          width: 100%;
          height: 100%;
        "
      ></div>
    </foreignObject>
    <path d="M12.288 5.403v.023l.018-.023h-.018Z" fill="#000" />
    <path
      d="M11.577 8.99v3.699H7.873c-1.01 0-1.878-.36-2.605-1.08a3.55 3.55 0 0 1-1.09-2.62c0-1.026.364-1.902 1.09-2.628.727-.726 1.595-1.09 2.605-1.09s1.88.364 2.61 1.09c.729.726 1.094 1.602 1.094 2.628Zm-1.551 2.225V8.989c0-.612-.209-1.138-.626-1.58a2.026 2.026 0 0 0-1.532-.663c-.603 0-1.113.22-1.531.663a2.222 2.222 0 0 0-.626 1.58c0 .612.208 1.136.626 1.572a2.04 2.04 0 0 0 1.531.654h2.158Zm3.028-3.72c-.31 0-.588-.133-.766-.34v4.138c0 .382.15.71.452.985a1.55 1.55 0 0 0 1.08.411V7.437a1.33 1.33 0 0 0-.023-.255 1.013 1.013 0 0 1-.743.313Z"
      fill="#E6E6E6"
    />
    <path
      d="M13.056 6.966a.758.758 0 0 0 .751-.764.758.758 0 0 0-.752-.764.758.758 0 0 0-.751.764c0 .422.336.764.752.764Z"
      fill="#fff"
    />
  </svg>
  <span style="white-space: nowrap; font-size : 12px; color: #0091BA; font-family: Figtree; font-weight: 600;">Magic Clean</span>
</span>`

const RichTextEditor = props => {
  const {
    placeholder,
    value,
    onChange,
    onBlur,
    readOnly = false,
    editorHeight,
    theme,
    className,
    containerClassName,
    style,
    modules,
    formats,
    onKeyDown,
    customIcon,
    customFunctionality,
    key,
  } = props

  const quillRef = useRef()

  const handleCustomFunctionality = () => {
    let notes = ""
    if (quillRef.current) {
      const editor = quillRef.current.getEditor()
      notes = editor.getText()
    }
    customFunctionality(notes)
  }

  const registerCustomButton = customIcon => {
    const toolbar = Quill.import("modules/toolbar")
    toolbar.DEFAULTS.handlers = {
      ...toolbar.DEFAULTS.handlers,
      [customIcon]: function () {
        handleCustomFunctionality()
      },
    }
  }
  customIcon && registerCustomButton(customIcon)

  return (
    <div className={cx(styles.editorContainer, containerClassName)}>
      <ReactQuill
        key={key || "default"}
        ref={quillRef}
        style={{ ...style }}
        modules={modules}
        formats={formats}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        readOnly={readOnly}
      />
    </div>
  )
}
export default RichTextEditor
